import { render } from "./Cancellation.vue?vue&type=template&id=686f4a5b&ts=true"
import script from "./Cancellation.vue?vue&type=script&lang=ts"
export * from "./Cancellation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__